import { canCallApp } from '../utils.js';
const appPdf = () => {
    document.querySelectorAll( 'a[data-app-pdf]' ).forEach( a => {
        if ( canCallApp( 'openPdf' ) ) {
            a.addEventListener( 'click', e => {
                e.preventDefault();
                Trendier.openPdf( a.href );
            } );
        }
    } );
};

export default appPdf;
